<div class="mc-dropdown-item-wrapper">
    <ng-content></ng-content>
</div>
<i *ngIf="isNested" mc-icon="mc-angle-right-M_16" class="mc-dropdown-trigger__icon"></i>
<div class="mc-dropdown-item-overlay" (click)="haltDisabledEvents($event)"></div>
